import { useState, useEffect } from 'react'

export const useTranslationMessage = () => {
  const [showTranslationMessage, setShowTranslationMessage] = useState(false)

  useEffect(() => {
    // This code only runs on the client
    const getLanguageFromCookie = () => {
      const match = document.cookie.match(/(?:^|;\s*)googtrans=([^;]*)/)
      return match ? match[1].split('/')[2] || 'en' : 'en'
    }

    const language = getLanguageFromCookie()

    if (language !== 'en') {
      setShowTranslationMessage(true)
    } else {
      setShowTranslationMessage(false)
    }
  }, [])

  return showTranslationMessage
}
